import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { Observable, of, BehaviorSubject, throwError } from 'rxjs';
import { License, LicenseTypes, FrequencyTypes } from '../models/license';

import { timezones } from '../models/timezones';
import {
  startWith,
  map,
  tap,
  filter,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  debounce,
  finalize,
} from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AccountService } from '../account.service';
import { KioskService } from '../kiosk.service';
import { MatStepper, MatSnackBar } from '@angular/material';
import { LicenseService } from '../license.service';
import { Device } from '../models/kiosk';

@Component({
  selector: 'app-kiosk-setup-wizard',
  templateUrl: './kiosk-setup-wizard.component.html',
  styleUrls: ['./kiosk-setup-wizard.component.css'],
})
export class KioskSetupWizardComponent implements OnInit {
  @ViewChild(MatStepper) wizard: MatStepper;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  fourthFormGroup: FormGroup;

  accountsList: string[] = [];

  kiosk$: BehaviorSubject<any> = new BehaviorSubject({});
  showNewForm: boolean;
  memberLimitReached: boolean;
  timezones$: any = timezones;
  filteredTimezones: string[];
  stateGroupOptions: Observable<any[]>;

  license: License;
  licenseSaved = false;

  // messy, needs to be cleaned up
  currentKiosk: any;
  currentDevice: any;
  currentAccount: any;

  licenseTypes: any = [
    { name: 'hearkiosk din', value: LicenseTypes.HEARKIOSKDIN },
    { name: 'hearkiosk pta', value: LicenseTypes.HEARKIOSKPTA },
  ];
  isLoading: boolean;
  inviteList: string[] = [];

  constructor(
    private _fb: FormBuilder,
    private _http: HttpClient,
    private _accountService: AccountService,
    private _kioskService: KioskService,
    private _licenseService: LicenseService,
    public snackBar: MatSnackBar
  ) {

  }
  ngOnInit() {
    this.showNewForm = false;
    this.createForm();
    this.setupTimezoneFilter();
  }

  setupTimezoneFilter() {
    this.stateGroupOptions = this.fourthFormGroup.get('timezone').valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterGroup(value))
      );
  }

  setAccount(e) {
    this.currentAccount = e;
  }

  displayFnAccount(val: any) {
    return val.email;
  }

  createForm() {
    this.firstFormGroup = this._fb.group({
      device: this._fb.group({
        id: [''],
        imei: ['', Validators.required],
        model: ['', Validators.required],
        data: ['']
      }),
      imei: [''],
    });
    this.secondFormGroup = this._fb.group({
      id: ['', Validators.required],
    });
    this.thirdFormGroup = this._fb.group({});
    this.fourthFormGroup = this._fb.group({
      multi_tenant: [false, Validators.required],
      timezone: ['', Validators.required],
      nickname: ['', Validators.required],
      cellphone_number: ['', Validators.required],
      tenants: this._fb.array([], [Validators.minLength(1), Validators. maxLength(4)]),
    });
  }

  createFormTenant(): FormGroup {
    return this._fb.group({
      email: ['', Validators.required],
      account_id: ['', Validators.required],
      name: ['', Validators.required],
    });
  }

  cancelNewKiosk() {
    this.showNewForm = !this.showNewForm;
    this.firstFormGroup.get('device').setValue({
      imei: '',
      model: '',
    });
  }


  saveMemberList(inviteList: string[]) {
    console.log('========> ', inviteList);
    const memberList = this.fourthFormGroup.get('member_list');
    const shared = this.fourthFormGroup.get('multi_tenant').value;

    if (!shared) {
      inviteList = [];
    }
    memberList.patchValue({ member_list: [...inviteList] });
  }

  addMember(member: string) {
    if (this.inviteList.length >= 4) {
      this.memberLimitReached = true;
      return;
    } else {
      this.inviteList.push(member);
      this.memberLimitReached = false;
    }
  }

  inviteTenants() {
    const ts = [];
    this.fourthFormGroup.get('tenants').value.forEach(element => {
      ts.push({
        account_id: element.account_id,
        contact: {
          name: element.name
        }
      });
    });
    this._kioskService.inviteTenants({ tenants: ts, kiosk_id: this.currentKiosk.id}).subscribe(
      (data) => {
        this.wizard.next();
      },
      (error: HttpErrorResponse) => {
        console.log('an error occurred', error);
        this.snackBar.open('Error:' + error.error.code, 'Okay', {
          duration: 2000,
        });
      }
    );
  }

  saveKiosk() {
    const k = {
      device: this.currentDevice,
      owner: this.secondFormGroup.get('id').value, // make res to filter by id?
      multi_tenant: this.fourthFormGroup.get('multi_tenant').value,
      timezone: this.fourthFormGroup.get('timezone').value,
    };

    if (k.device && k.device.id && k.device.id !== 0)  {
      console.log('device exists, finding kiosk');
      this._kioskService.getKioskByDeviceId(k.device.id).subscribe(
        (data) => {
          // TODO store kiosk response
          console.log('getKioskByDeviceId---', data);
          this.currentKiosk = data;
          this.fourthFormGroup.get('nickname').setValue(this.currentKiosk.nickname);
          this.fourthFormGroup.get('timezone').setValue(this.currentKiosk.timezone);
          this.fourthFormGroup.get('cellphone_number').setValue(this.currentKiosk.cellphone_number);
          this.fourthFormGroup.get('multi_tenant').setValue(this.currentKiosk.multi_tenant);

          this.wizard.next();
        }, (error: HttpErrorResponse) => {
          console.log('an error occurred', error);
          this.snackBar.open('Error:' + error, 'Okay', {
            duration: 2000,
          });
        }
      );
    } else {
      console.log('creating kiosk')
      this._kioskService.createKiosk({ imei: this.firstFormGroup.get('device.imei').value,
       model: this.firstFormGroup.get('device.model').value}).subscribe(
        (data) => {
          // TODO store kiosk response
          console.log('created kiosk resp', data);
          this.currentKiosk = data.kiosk;
          this.fourthFormGroup.get('nickname').setValue(this.currentKiosk.nickname);
          this.fourthFormGroup.get('timezone').setValue(this.currentKiosk.timezone);
          this.fourthFormGroup.get('cellphone_number').setValue(this.currentKiosk.cellphone_number);
          this.fourthFormGroup.get('multi_tenant').setValue(this.currentKiosk.multi_tenant);

          this.currentDevice = data.device;
          this.wizard.next();
        }, (error: HttpErrorResponse) => {
          console.log('an error occurred', error);
          this.snackBar.open('Error:' + error.error.code, 'Okay', {
            duration: 2000,
          });
        }
      );
    }

    console.log(k);
  }

  inviteAccount(acc) {
    console.log('inviting account', acc);
    if (this.inviteList.filter((x: any) => x.id === acc.id).length === 0) {
      this.inviteList.push(acc);
      const a = <FormArray>this.fourthFormGroup.controls['tenants'];

      const  b = this.createFormTenant();
      b.get('account_id').setValue(acc.id);
      b.get('email').setValue(acc.email);
      a.push(b);
    }
  }

  removeMember(i: number) {
    this.inviteList.splice(i, 1);
    this.memberLimitReached = false;
    const a = <FormArray>this.fourthFormGroup.controls['tenants'];
    a.removeAt(i);
  }

  changeKiosk() {
    this._kioskService.updateKiosk(this.currentKiosk.id, {
      timezone: this.fourthFormGroup.get('timezone').value,
      multi_tenant: this.fourthFormGroup.get('multi_tenant').value,
      nickname: this.fourthFormGroup.get('nickname').value,
      cellphone_number: this.fourthFormGroup.get('cellphone_number').value,
      company: "hearxgroup",
      locked: false,
    }).subscribe(
      (data) => {
        // TODO store kiosk response
        console.log('getKioskByDeviceId', data);
        this.wizard.next();
      }, (error: HttpErrorResponse) => {
        console.log('an error occurred', error.error.code);
        this.snackBar.open('Error:' + error.error.code, 'Okay', {
          duration: 2000,
        });
      }
    );
  }

  linkKioskToLicense() {
    this._licenseService.LinkLicenseToDevice(this.license.id, this.currentDevice.id).subscribe(
      (data) => {
        // TODO store kiosk response
        console.log('LinkLicenseToDevice', data);
        this.wizard.next();
      }, (error: HttpErrorResponse) => {
        console.log('an error occurred', error);
        this.snackBar.open('Error:' + error.error.error, 'Okay', {
          duration: 2000,
        });
      }
    );
  }

  linkKioskToAccount() {
    console.log('device exists, finding kiosk');
    // this whole formgroup thing doesn't seem to be working - Its not id -
    // the autocomplete replaces it with an object - we need the object too.
    // Thoughts? Having to rush this so im not too phased for poor tools
    this._kioskService.linkKioskToAccount({ accountId: this.currentAccount.id, kioskId: this.currentKiosk.id}).subscribe(
      (data) => {
        console.log('linkKioskToAccount', data);

        this.wizard.next();
      }, (error: HttpErrorResponse) => {
        // Toast for error
        this.snackBar.open('Error:' + error.error.code, 'Okay', {
          duration: 2000,
        });
        console.log('an error occurred', error);
      }
    );
  }


  saveLicense(license: License) {
    console.log('GOT LICENSE ', license);
    this.license = license;
    this.licenseSaved = true;
  }

  setDevice(item: Device) {
    this.currentDevice = item;
    this.firstFormGroup.get('device').setValue(item);
  }

  saveFinal() {
    const kiosk = this.kiosk$.getValue();
    console.log(kiosk);
    const device = this.firstFormGroup.get('device').value;

    // REGISTER KIOSK
  }

  private _linkKioskToAccount(account_id: number, kiosk_id: number) {
    const body = {
      accountId: account_id,
      kioskId: kiosk_id
    };

    this._kioskService.linkKioskToAccount(body)
      .subscribe();
  }

  private _filterGroup(value: string): any[] {
    if (value) {
      return this.timezones$
        .map(group => ({ heading: group.heading, zones: _filter(group.zones, value) }))
        .filter(group => group.zones.length > 0);
    }

    return this.timezones$;
  }

}

export const _filter = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => {
    return item.toLowerCase().includes(filterValue);
  });
};



// WEBPACK FOOTER //
// ./src/app/kiosk-setup-wizard/kiosk-setup-wizard.component.ts